<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>
          HISTORIAL
        </ion-title>
        <ion-buttons slot="end">
          <ion-button @click="muestraModalFiltros();">
            <h5 v-if="!filtros.filtroFecha && !filtros.filtroSucursal" class="mb-0 mr-2"><fa :icon="['fas', 'search']"></fa></h5>
            <h5 v-else class="mb-0 mr-2 text-warning"><fa :icon="['fas', 'search']"></fa></h5>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    
    <ion-content>
      <ion-refresher slot="fixed" @ionRefresh="listarHistorialEventosNuevo($event, true);" >
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
      
      <div v-if="eventos.length > 0">
        <!-- <ion-card v-for="evento in eventos" :key="evento.evt_id" :color="evento.color" style="cursor:pointer;" @click="muestraModalEvento(evento)">
          <div class="container-fluid p-3">
            <div class="row">
              <div class="col">
                <h5 class="ion-text-start ion-no-padding ion-no-margin">
                  <fa v-if="evento.tev_prioridad == 1" :icon="['fad', 'exclamation-circle']"  ></fa>
                  <fa v-if="evento.tev_prioridad == 2" :icon="['fad', 'exclamation-triangle']"></fa>
                  <fa v-if="evento.tev_prioridad == 3" :icon="['fad', 'exclamation-square']"  ></fa>
                  {{evento.tev_tipo}}
                </h5>
              </div>
              <div class="col-sm-12 col-md-6 text-md-right mt-2 mt-md-0">
                <ion-label v-if="evento.grupo == 1"><span class="font-weight-bold">FALLA MASIVA</span></ion-label>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col">
                <ion-label color="dark">
                  {{  
                    evento.estado_actual.hev_fecha_hora.split(' ')[0].split('-')[2] + '-' +
                    evento.estado_actual.hev_fecha_hora.split(' ')[0].split('-')[1] + '-' +
                    evento.estado_actual.hev_fecha_hora.split(' ')[0].split('-')[0] + ' ' +
                    evento.estado_actual.hev_fecha_hora.split(' ')[1].split(':')[0] + ':' +
                    evento.estado_actual.hev_fecha_hora.split(' ')[1].split(':')[1]
                  }}
                </ion-label>
              </div>
              <div class="col text-right">
                <ion-label><span>{{evento.estado_actual.tpe_estado}}</span></ion-label>
              </div>
            </div>
          </div>
        </ion-card> -->
        <ion-card v-for="evento in eventos" :key="evento.evt_id" :color="evento.color" style="cursor:pointer;" @click="muestraModalEvento(evento)">
        <div class="container-fluid p-3">
          <div class="row" style="font-size:small;">
            <div class="col">Ticket {{ evento.evt_id }}</div>
            <div class="col text-right">
              <ion-label>
                {{  
                  evento.estado_actual.hev_fecha_hora.split(' ')[0].split('-')[2] + '/' +
                  evento.estado_actual.hev_fecha_hora.split(' ')[0].split('-')[1] + '/' +
                  evento.estado_actual.hev_fecha_hora.split(' ')[0].split('-')[0] + ' ' +
                  evento.estado_actual.hev_fecha_hora.split(' ')[1].split(':')[0] + ':' +
                  evento.estado_actual.hev_fecha_hora.split(' ')[1].split(':')[1]
                }}
              </ion-label>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h5 class="ion-text-start ion-no-padding ion-no-margin">
                <fa v-if="evento.tev_prioridad == 1" :icon="['fas', 'exclamation-circle']"  ></fa>
                <fa v-if="evento.tev_prioridad == 2" :icon="['fas', 'exclamation-triangle']"></fa>
                <fa v-if="evento.tev_prioridad == 3" :icon="['fas', 'exclamation']"  ></fa>
                {{evento.tev_tipo}}
              </h5>
            </div>
            <div class="col-sm-12 col-md-6 text-md-right mt-2 mt-md-0">
              <ion-label v-if="evento.grupo == 1"><span class="font-weight-bold">FALLA MASIVA</span></ion-label>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <ion-label>
                {{  
                  /* evento.evt_empresa_origen+' | '+ */evento.evt_sucursal_origen
                }}
              </ion-label>
            </div>
            <div class="col text-right font-weight-bold">
              <ion-label><span>{{evento.estado_actual.tpe_estado}}</span></ion-label>
            </div>
          </div>
        </div>
      </ion-card>
      </div>
      <div v-else class="row mt-3">
        <div class="col text-center">
          SIN REGISTROS PARA LISTAR.
        </div>
      </div>
      <ion-infinite-scroll @ionInfinite="listarHistorialEventosNuevo($event)">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-content>
    
  </ion-page>
</template>

<script>
import { 
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonMenuButton, IonButtons, IonLabel, toastController, IonCard, IonRefresher, 
  IonRefresherContent, modalController, loadingController, IonInfiniteScroll, IonInfiniteScrollContent
} from '@ionic/vue';

import { addIcons        } from 'ionicons';
import { closeOutline, alertCircleOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';
import { Preferences     } from '@capacitor/preferences';
import { cerrarSesion    } from '@/plugins/funciones.ts';
import axios               from 'axios';
import rutaBase            from '@/plugins/variables';
import mEvento             from '../../components/ModalEvento.vue';
import mFiltros            from './ModalFiltrosHistorial.vue';

export default defineComponent({
  name: 'Historial',
  components: {
    IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonMenuButton, IonButtons, IonLabel, IonCard, IonRefresher, IonRefresherContent, IonInfiniteScroll, IonInfiniteScrollContent
  },
  data() {
    return { 
      eventos       : [],
      modalEvento   : null,
      modalFiltros  : null,
      rango         : 0,
      filtros       : {filtroSucursal:false, empresa:'', sucursal:'', filtroFecha:false, ano:'', mes:'', filtroTipo:false, tipo:''},
    }
  },
  created() {
    addIcons({
      'close-outline' : closeOutline,
      'alert-circle-outline': alertCircleOutline
    });
  },
  mounted(){
    this.listarHistorialEventosNuevo();
  },
  methods: {

    async muestraModalCargando(){
      this.modalCargando = await loadingController
        .create({
          cssClass  : 'text-secondary',
          message   : 'CARGANDO...',
          animated  : false,
          mode      : 'md'
        });
      await this.modalCargando.present();
    },

    async listarHistorialEventosNuevo(ev=null, recarga=false){
      await this.muestraModalCargando();
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const dato        = new URLSearchParams();
      if(recarga) { this.rango = 0}
      dato.append('rango', this.rango);
      dato.append('filtros', JSON.stringify(this.filtros));
      axios.post(rutaBase+'/soporte/listarHistorialEventosNuevo', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        if(recarga){
          this.eventos = resp.data.eventos;
        }
        else{
          this.eventos = this.eventos.concat(resp.data.eventos);
        }
        if(this.eventos.length > 0){
          this.rango   = this.eventos[this.eventos.length-1].evt_id;
        }
        if(ev){ ev.target.complete(); }
        this.modalCargando.dismiss();
      }).catch(() =>{
        this.modalCargando.dismiss();
        this.muestraToast('ERROR AL LISTAR EVENTOS.');
      });
    },

    async listarHistorialEventos(){
      await this.muestraModalCargando();
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const dato        = new URLSearchParams();
      axios.post(rutaBase+'/soporte/listarHistorialEventos', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.eventos = resp.data.eventos;
        this.modalCargando.dismiss();
      }).catch(() =>{
        this.modalCargando.dismiss();
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async recargarHistorialEventos(evento=false){
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const dato        = new URLSearchParams();
      axios.post(rutaBase+'/soporte/listarHistorialEventos', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.eventos = resp.data.eventos;
        if(evento){ evento.target.complete(); }
      }).catch(() =>{
        if(evento){ evento.target.complete(); }
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async muestraModalEvento(evento){
      this.modalEvento = await modalController
        .create({
          component: mEvento,
          componentProps: {
            propEvento  : evento,
            modal       : this.modalEvento
          }
        });
      this.modalEvento.present();
      const modalResponse = await this.modalEvento.onDidDismiss();
      modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    async muestraModalFiltros(){
      this.modalFiltros = await modalController
        .create({
          component: mFiltros,
          componentProps: {
            modal         : this.modalFiltros,
            propFiltros   : this.filtros
          }
        });
      this.modalFiltros.present();
      const modalResponse = await this.modalFiltros.onDidDismiss();
      modalResponse.data && this.modalCloseFiltros({...modalResponse.data})
    },

    modalCloseHandler(_value) {
      const datos = _value;
      /* if(datos.recargar){
        this.listarHistorialEventosNuevo();
      } */
    },

    modalCloseFiltros(_value) {
      const datos = _value;
      if(datos.recargar){
        this.filtros = JSON.parse(JSON.stringify(datos.filtros));
        console.log(this.filtros);
        this.listarHistorialEventosNuevo(null, true);
      }
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    }
  }
});
</script>
